import React from "react";
import { OverlayMask } from "./styles";
import Spinner from "../../../components/Spinner";

export const WaitMessageOverlay = ({ show, message }) => {
  return (
    <OverlayMask show={show}>
      <div id="overlay-message-box">
        <div id="overlay-message">
          <Spinner height="40px" margin="0px" width="auto" />
          <span style={{ marginLeft: "8px" }}>{message}</span>
        </div>
      </div>
    </OverlayMask>
  );
};
